import { styled } from '@mui/material'
import { ZKEX_SYMBOL_TO_BINANCE_API } from 'constants/chart'
import { FC, memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useCurrentSymbol } from 'store/market/hooks'
import { updateCurrentChartTab } from 'store/orderbook/actions'
import { useCurrentChartTab } from 'store/orderbook/hooks'
import { TradingViewKLintType } from 'store/orderbook/reducer'
import { Flex } from 'styles'
import clsx from 'clsx'

const ChartHeaderWrap = styled(Flex)`
  align-items: center;
  height: 40px;
  flex-shrink: 0;
  padding: 0 8px;
  background: ${({ theme }) => theme.color.bg};
  border-bottom: 1px solid ${({ theme }) => theme.color.text10};

  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`
const ChartLineType = styled(Flex)`
  align-items: center;
  height: 100%;
`
const ChartLineTypeItem = styled('div')`
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: rgba(149, 164, 173, 1);
  padding: 2px 12px;
  cursor: pointer;
  user-select: none;

  &:hover {
    color: ${({ theme }) => theme.color.text100};
  }

  &.active {
    color: rgba(160, 238, 9, 1);
  }
`

export const ChartHeader: FC = memo(() => {
  const dispatch = useDispatch()
  const currentChartTab = useCurrentChartTab()

  const { name: id = '', trade = 'SPOTS' } = useCurrentSymbol()

  useEffect(() => {
    if (id && !ZKEX_SYMBOL_TO_BINANCE_API[id]) {
      dispatch(updateCurrentChartTab(TradingViewKLintType.ZKEX))
    }

    if (id && ZKEX_SYMBOL_TO_BINANCE_API[id]) {
      dispatch(updateCurrentChartTab(TradingViewKLintType.BINANCE))
    }
  }, [dispatch, id])

  return (
    <ChartHeaderWrap>
      <ChartLineType>
        {/* <ChartLineTypeItem
          key={TradingViewKLintType.ORIGINAL}
          className={clsx({
            active: currentChartTab === TradingViewKLintType.ORIGINAL,
          })}
          onClick={() => {
            dispatch(updateCurrentChartTab(TradingViewKLintType.ORIGINAL))
          }}
        >
          ZKEX Original
        </ChartLineTypeItem> */}
        <ChartLineTypeItem
          key={TradingViewKLintType.ZKEX}
          className={clsx({
            active: currentChartTab === TradingViewKLintType.ZKEX,
          })}
          onClick={() => {
            dispatch(updateCurrentChartTab(TradingViewKLintType.ZKEX))
          }}
        >
          ZKEX Original
        </ChartLineTypeItem>
        {ZKEX_SYMBOL_TO_BINANCE_API[id] ? (
          <ChartLineTypeItem
            key={TradingViewKLintType.BINANCE}
            className={clsx({
              active: currentChartTab === TradingViewKLintType.BINANCE,
            })}
            onClick={() => {
              dispatch(updateCurrentChartTab(TradingViewKLintType.BINANCE))
            }}
          >
            Binance
          </ChartLineTypeItem>
        ) : null}

        {trade === 'CONTRACTS' && (
          <ChartLineTypeItem
            key={TradingViewKLintType.INFO}
            className={clsx({
              active: currentChartTab === TradingViewKLintType.INFO,
            })}
            onClick={() => {
              dispatch(updateCurrentChartTab(TradingViewKLintType.INFO))
            }}
          >
            Info
          </ChartLineTypeItem>
        )}
      </ChartLineType>
    </ChartHeaderWrap>
  )
})
